import { usePassportProvider } from "@/context";
import { useGetWalletLatestEarnings } from "@/hooks/api";
import { useQuests } from "@/hooks/cms";
import { QuestsSection } from "@components/TilesSection/QuestsSection";
import { QuestTileType } from "@imx-tokens-ts/gems-game/domain";
import { mainAndSideFilterOptions } from "../utils";

export const SideQuests = ({ scrollToIndex }: { scrollToIndex?: number }) => {
  const { data, isLoading } = useQuests();
  const sideQuests = data?.sideQuests || [];
  const { walletAddress } = usePassportProvider();
  const { latestEarnings } = useGetWalletLatestEarnings(walletAddress);
  return (
    <QuestsSection
      tileType={QuestTileType.SideQuest}
      title="Faster Quests. Easy Rewards."
      description="Fastest way to rack up Gems."
      filterOptions={mainAndSideFilterOptions}
      data={sideQuests}
      latestEarnings={latestEarnings}
      scrollToIndex={scrollToIndex}
      isLoading={isLoading}
    />
  );
};
